import { render, staticRenderFns } from "./ClaimContentTop.vue?vue&type=template&id=00697039&"
import script from "./ClaimContentTop.vue?vue&type=script&lang=ts&"
export * from "./ClaimContentTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports